import Keycloak from "keycloak-js";
import Cookies from "js-cookie";
import {getComplementaryUrl, isComplementaryOrigin} from "../config";

var keycloak = new Keycloak(process.env.REACT_APP_KEYCLOAK_JSON);

var userInfo = {email: ""};

function initKeycloak(setLoggedIn, setAuthz) {
    keycloak = new Keycloak(process.env.REACT_APP_KEYCLOAK_JSON);
    let userTokens = getUserTokens();
    let initOptions = !!userTokens
        ? userTokens
        : {
            onLoad: "check-sso",
            checkLoginIframe: true,
            responseMode: "query",
            pkceMethod: false,
            silentCheckSsoRedirectUri:
                window.location.origin + "/silent-check-sso.html",
        };
    setAuthorizing(true, setAuthz);
    return keycloak.init(initOptions)
}

/**
 * type KeycloakConfig {
 *      url: string;
 *      realm: string;
 *      clientId: string;
 * }
 */
const issuerConfig = {
    url: process.env.REACT_APP_AUTH_ISSUER_URL,
    realm: process.env.REACT_APP_AUTH_ISSUER_REALM,
}

function dynamicLogin({clientId, redirectUri}) {
    let dynamicClient = new Keycloak({
        ...issuerConfig,
        clientId: clientId
    })
    return dynamicClient.init({
        onLoad: undefined,
        checkLoginIframe: false,
        pkceMethod: false,
        responseMode: "query"
    }).then(status => dynamicClient.login({redirectUri: redirectUri}))
}

function doLogin(redirect_uri) {
    const locale = Cookies.get("ui_locale")
    if(isComplementaryOrigin()) {
        doLoginComplementary()
    } else {
        keycloak.login({redirectUri: redirect_uri, locale: locale});
    }
}

function doRegister(redirect_uri) {
    if (!isLoggedIn()) {
        if(isComplementaryOrigin()) {
            return doRegisterComplementary();
        }
        return doRegisterPlatform(redirect_uri);
    }
}

const doLoginPlatform = (redirect_uri) => {
    if(isComplementaryOrigin())
        return doLoginComplementary();

    const locale = Cookies.get("ui_locale");
    let platformClient = new Keycloak(process.env?.REACT_APP_KEYCLOAK_WEB_JSON ?? "");
    return platformClient.init({ onLoad: undefined, checkLoginIframe: false, pkceMethod: false, responseMode: "query"})
        .then(result => platformClient.login({redirectUri: redirect_uri, locale: locale}));
};

const doRegisterPlatform = (redirect_uri) => {
    const locale = Cookies.get("ui_locale");
    let platformClient = new Keycloak(process.env?.REACT_APP_KEYCLOAK_WEB_JSON ?? "");
    return platformClient.init({ onLoad: undefined, checkLoginIframe: false, pkceMethod: false, responseMode: "query"})
        .then(result => platformClient.register({redirectUri: redirect_uri, locale: locale}));
};

function doLoginComplementary() {
    const locale = Cookies.get("ui_locale");
    return keycloak.login({redirectUri: `${getComplementaryUrl()}/Account`, locale: locale});
}

function doRegisterComplementary() {
    const locale = Cookies.get("ui_locale");
    return keycloak.register({redirectUri: `${getComplementaryUrl()}/Account`, locale: locale});
}

function doLogout() {
    localStorage.removeItem("kc_tok");
    sessionStorage.removeItem("kc_tok");
    // console.log(keycloak)
    !!keycloak && keycloak.logout();
}

function isLoggedIn() {
    return keycloak.authenticated;
}

function updateUserTokens(force) {
    let url = new URL(window.location.href);
    let searchParams = url.searchParams;
    let referer = searchParams.get("referer")
        || (sessionStorage.getItem("kc_tok") && JSON.parse(sessionStorage.getItem("kc_tok")).referer)
        || (localStorage.getItem("kc_tok") && JSON.parse(localStorage.getItem("kc_tok")).referer)
        || null;

    return keycloak
        .updateToken(force ? 9999 : undefined)
        .then(() => {
            //console.log("successfully get a new token", keycloak.token);
            localStorage.setItem(
                "kc_tok",
                JSON.stringify({
                    token: keycloak.token,
                    refreshToken: keycloak.refreshToken,
                    idToken: keycloak.idToken,
                    ...(referer ? { referer } : {})
                })
            );
            sessionStorage.setItem(
                "kc_tok",
                JSON.stringify({
                    token: keycloak.token,
                    refreshToken: keycloak.refreshToken,
                    idToken: keycloak.idToken,
                    ...(referer ? { referer } : {})
                })
            );
            userInfo = keycloak.tokenParsed;
        })
        .catch(() => {
            const locale = Cookies.get("ui_locale");

            doLogout();
            doLogin(window.location.href, locale);
        });
}

function getToken() {
    return keycloak.token;
}

function getUserTokens() {
    //let tokens = localStorage.getItem("kc_tok");
    let tokens = sessionStorage.getItem("kc_tok");
    if (!!tokens) {
        let userTokens = JSON.parse(tokens);
        userTokens.onLoad = "check-sso";
        userTokens.checkLoginIframe = true;
        userTokens.responseMode = "query";
        userTokens.pkceMethod = false
        userTokens.silentCheckSsoRedirectUri =
            window.location.origin + "/silent-check-sso.html";
        return userTokens;
    }
    return false;
}

function getUser() {
    return keycloak.loadUserInfo();
}

function clearUserTokens() {
    localStorage.removeItem("kc_tok");
    sessionStorage.removeItem("kc_tok");
}

function updatePassword() {
    const locale = Cookies.get("ui_locale");
    let url = window.location.origin;
    keycloak.login({
        redirectUri: url + "/PasswordUpdate",
        locale: locale,
        action: "UPDATE_PASSWORD",
    });
}

function updateProfile() {
    let url = window.location.origin;
    const locale = Cookies.get("ui_locale");
    keycloak.login({
        redirectUri: url + "/Account",
        locale: locale,
        action: "UPDATE_PROFILE",
    });
}

keycloak.onTokenExpired = () => {
    //console.log("token expired", keycloak.token);
    // console.log("token expired");
    keycloak
        .updateToken()
        .then(() => {
            //console.log("successfully get a new token", keycloak.token);
            // console.log("successfully get a new token");
            sessionStorage.setItem(
                "kc_tok",
                JSON.stringify({
                    token: keycloak.token,
                    refreshToken: keycloak.refreshToken,
                    idToken: keycloak.idToken,
                })
            );
        })
        .catch(() => {
            console.log("error updating token");
        });
};

function isAuthorizing() {
    return !!sessionStorage.getItem("kc_loading");
}

function setAuthorizing(auth, fn) {
    if (auth) sessionStorage.setItem("kc_loading", true);
    else sessionStorage.removeItem("kc_loading");
    fn(auth);
}

function isSubscriptionAction() {
    let url = new URL(window.location.href);
    let searchParams = url.searchParams;
    let challengeUrl = searchParams.get("action_challenge");
    if (!!challengeUrl) {
        challengeUrl = new URL(challengeUrl);
        let challengeSearchParams = new URLSearchParams(challengeUrl.search);
        let actionTokenString = challengeSearchParams.get("key");

        sessionStorage.setItem(
            "kc_action",
            JSON.stringify({
                challenge: challengeUrl,
                token: actionTokenString,
                client_id: challengeSearchParams.get("client_id"),
            })
        );
        searchParams.delete("action_challenge");
        window.history.replaceState(null, '', url);
    }
    let kcActionString = sessionStorage.getItem("kc_action");
    if (!!kcActionString) {
        let kcAction = JSON.parse(kcActionString);
        let token = parseJwt(kcAction.token);
        if (hasJwtExpired(token)) {
            clearActionToken();
            return false;
        }
        return true;
    }
    return false;
}

function resolveSubscriptionAction(token, sessionRedirect = true, redirectURL) {
    let kcAction = JSON.parse(sessionStorage.getItem("kc_action"));
    sessionStorage.removeItem("kc_action");
    sessionStorage.removeItem("kc_resolve_token");
    if (!!token) {
        let redirectBack = new URL(kcAction?.challenge.replace("%7Bchallenge%7D", token));
        window.location.replace(`${redirectBack}`);
    } else {
        if (!!sessionRedirect && !!redirectURL) {
            window.location.replace(`${redirectURL}`);
        }
    }
}

function setOTPOnActionToken() {
    let kc_action = sessionStorage.getItem("kc_action");
    if(!!kc_action){
        kc_action = JSON.parse(sessionStorage.getItem("kc_action"))
        kc_action.otpVerified = true;
        sessionStorage.setItem("kc_action", JSON.stringify(kc_action));
    }
}

function getOTPFromActionToken() {
    let kc_action = sessionStorage.getItem("kc_action");
    if(!!kc_action){
        kc_action = JSON.parse(sessionStorage.getItem("kc_action"))
        return kc_action.otpVerified ?? false;
    }
    return false;
}
function clearActionToken() {
    sessionStorage.removeItem("kc_action");
}

function hasJwtExpired(token) {
    return calculateExpiresInSeconds(token) < 0;
}

function calculateExpiresInSeconds(token) {
    return token.exp - new Date().getTime() / 1000;
}

// function calculateExpiresInMillis(token) {
//   return token.exp * 1000 - new Date().getTime();
// }

function parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    return JSON.parse(jsonPayload);
}

const UserService = {
    initKeycloak,
    isAuthorizing,
    setAuthorizing,
    doLogin,
    doLogout,
    dynamicLogin,
    doLoginPlatform,
    doRegisterPlatform,
    isLoggedIn,
    getToken,
    getUserTokens,
    clearUserTokens,
    updateUserTokens,
    doRegister,
    getUser,
    updatePassword,
    updateProfile,
    isSubscriptionAction,
    resolveSubscriptionAction,
    clearActionToken,
    setOTPOnActionToken,
    getOTPFromActionToken
};

export default UserService;
